import { useState } from 'react';
import { Gift, X } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

export function RedeemCodeModal({ onClose }: { onClose: () => void }) {
  const { redeemCode } = useAuth();
  const [code, setCode] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  async function submit(event: React.FormEvent) {
    event.preventDefault(); setSaving(true); setError('');
    try {
      const result = await redeemCode(code);
      setSuccess(result.message || `已领取 ${result.durationDays} 天专业版权益`);
    } catch (reason) { setError(reason instanceof Error ? reason.message : '兑换失败'); }
    finally { setSaving(false); }
  }
  return <div className="modal-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="redeem-code-modal" role="dialog" aria-modal="true" aria-labelledby="redeem-code-title">
      <button className="modal-close icon-button" type="button" onClick={onClose} aria-label="关闭"><X size={18} /></button>
      <span className="redeem-code-icon"><Gift size={28} /></span>
      <h2 id="redeem-code-title">兑换专业版权益</h2>
      <p>输入合作活动或官方发放的兑换码，成功后权益会立即同步到当前账号。</p>
      {success ? <div className="redeem-success"><strong>兑换成功</strong><span>{success}</span><button className="primary-button" type="button" onClick={onClose}>完成</button></div> : <form onSubmit={submit}>
        <label>兑换码<input value={code} onChange={(event) => setCode(event.target.value.toUpperCase())} placeholder="YXMPD-XXXX-XXXX-XXXX" autoComplete="off" required /></label>
        {error && <div className="form-error" role="alert">{error}</div>}
        <button className="primary-button" type="submit" disabled={saving || !code.trim()}><Gift size={18} />{saving ? '正在兑换…' : '立即兑换'}</button>
      </form>}
    </section>
  </div>;
}
